export default "__VITE_ASSET__CoEF20Dr__"